import { Button, Table } from "antd";
import styled from "styled-components";

import { GiftItem } from "./index";

export const StyledPromoTable = styled(Table<GiftItem>)`
    width: 100%;

    th {
        text-align: center !important;
    }

    .disabled-row {
        opacity: 0.6;
    }
`;

export const StyledCopyButton = styled(Button)`
    margin-inline: auto;
    border-bottom: 1px dashed #5f5f5f;
`;
